'use client'

import {
  NotificationContextProvider,
  PusherProvider,
  QueryContextProvider,
  SdkProvider,
  useSession,
} from '@repo/sdk'
import { Session, User } from '@repo/sdk/auth'
import { SidebarProvider } from '@repo/ui'
import { ThemeProvider } from 'next-themes'
import { ReactNode, useEffect } from 'react'

export const Provider = ({
  children,
  session,
}: {
  children: ReactNode
  session: null | Session
}) => {
  return (
    <SdkProvider session={session}>
      <ThemeProvider attribute={'class'} defaultTheme={'light'} themes={['light', 'dark']}>
        {children}
      </ThemeProvider>
    </SdkProvider>
  )
}

export const AuthorizedProvider = ({ children, user }: { children: ReactNode; user: User }) => {
  const session = useSession()

  useEffect(() => {
    session.update()
  }, [])

  return (
    <PusherProvider accessToken={user?.access_token}>
      <NotificationContextProvider>
        <QueryContextProvider>
          <SidebarProvider defaultOpen={true}>{children}</SidebarProvider>
        </QueryContextProvider>
      </NotificationContextProvider>
    </PusherProvider>
  )
}
